import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import { useParams } from "react-router-dom";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
// https://codesandbox.io/s/rsk8d?file=/src/events.js:202-265
import { formatText } from "@_common/format-text";
import { Modal, ModalBody } from "reactstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { GetSpecificCheckpointPEComplianceTask } from "@services/checkpoint.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { convertDate } from "@_common/date-helpers";
import NoAccessPage from "@components/common/NoAccess";
import Toolbar from "react-big-calendar/lib/Toolbar";
import Loader from "@components/common/Loader";
import { getActivityMyTaskCalenderInfoIC } from "@services/internal-compliance.service";
import SubmenuArrowDownSvgComponent from "../../../../../assets/svg-components/left-menu/submenu-arrow-down";

interface ITaskCalenderViewProps {}

const ICActivitiesMyTaskCalenderView: React.FunctionComponent<ITaskCalenderViewProps> = (
  props: any
) => {
  const mainParams = useParams();
  const localizer = momentLocalizer(moment);
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [taskDates, setTaskDates] = useState([]);
  const [owner_due_date_from, setFirstDay] = useState(new Date());
  const [owner_due_date_to, setLastDay] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();

      let dates = params.date ? new Date(params.date) : new Date();
      var owner_due_date_from = new Date(
        dates.getFullYear(),
        dates.getMonth(),
        1
      );
      var owner_due_date_to = new Date(
        dates.getFullYear(),
        dates.getMonth() + 1,
        0
      );
      setFirstDay(owner_due_date_from);
      setLastDay(owner_due_date_to);
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.owner_due_date_from && params.owner_due_date_to) {
        // setDate(new Date(params.date));
        var owner_due_date_from = new Date(params.owner_due_date_from);
        var owner_due_date_to = new Date(params.owner_due_date_to);
        setFirstDay(owner_due_date_from);
        setLastDay(owner_due_date_to);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var owner_due_date_from = params.owner_due_date_from
      ? params.owner_due_date_from
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var owner_due_date_to = params.owner_due_date_to
      ? params.owner_due_date_to
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    try {
      let payload: any = {
        owner_due_date_from: moment(owner_due_date_from).format("YYYY-MM-DD"),
        owner_due_date_to: moment(owner_due_date_to).format("YYYY-MM-DD"),
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getActivityMyTaskCalenderInfoIC(queryRequest);
      if (resp) {
        let dates =
          getValue(resp, `data.result.length`, 0) > 0
            ? getValue(resp, `data.result`, []).filter(
                (item: any) =>
                  Object.entries(getValue(item, `data`, {})).length > 0
              )
            : [];
        let formattedDates: any = [];
        for (let i = 0; i < getValue(dates, `length`, 0); i++) {
          Object.entries(dates[i].data).length > 0 &&
            Object.entries(dates[i].data).filter((item: any) => {
              if (getValue(item, `[${1}].value.length`, 0) > 0)
                return formattedDates.push({
                  start: getValue(dates, `[${i}].date`, ""),
                  end: getValue(dates, `[${i}].date`, ""),
                  title: `${getValue(
                    item,
                    `[${1}].count`,
                    0
                  )}${" "}${formatText(getValue(item, `[${0}]`, ""))}`,
                  taskList: getValue(item, `[${1}].value`, ""),
                  name: getValue(item, `[${0}]`, ""),
                });
            });
        }
        setTaskDates(
          getValue(formattedDates, `length`, 0) > 0 ? formattedDates : []
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const [taskInfo, setTaskInfo] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const onSelectEventSlotHandler = (item: any) => {
    var owner_due_date_from = params.owner_due_date_from
      ? params.owner_due_date_from
      : new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    var owner_due_date_to = params.owner_due_date_to
      ? params.owner_due_date_to
      : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

    let compliance_task_ids =
      getValue(item, `taskList.length`, 0) > 0
        ? getValue(item, `taskList`, []).map((item: object) =>
            getValue(item, `id`, "")
          )
        : [];

    let payload = {
      ...params,
      compliance_task_ids: compliance_task_ids,
      owner_due_date_from: moment(owner_due_date_from).format("YYYY-MM-DD"),
      owner_due_date_to: moment(owner_due_date_to).format("YYYY-MM-DD"),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/activities/internal-compliance/my-task?${queryRequest}`);
    // setTaskInfo(item);
    // handleModal();
  };

  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };

  const handleSubmitDate = () => {
    let first: any = moment(owner_due_date_from).format("YYYY-MM-DD");
    let last: any = moment(owner_due_date_to).format("YYYY-MM-DD");
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        owner_due_date_from: first,
        owner_due_date_to: last,
      };
      if (payload.owner_due_date_from && payload.owner_due_date_to) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  //EVENT STYLE GETTER FOR SLYLING AN EVENT ITEM
  const eventStyleGetter = (
    event: any,
    start: any,
    end: any,
    isSelected: any
  ) => {
    // let current_time = moment().format('YYYY MM DD');
    // let event_time = moment(event.start).format('YYYY MM DD');
    let background =
      event.name === "due_task"
        ? "#FBF2F4"
        : event.name === "completed_task"
        ? "#07bc0c33"
        : "#1a73e85e ";
    let color =
      event.name === "due_task"
        ? "#D7242E"
        : event.name === "completed_task"
        ? "#05A357"
        : "#0a58ca";

    return {
      style: {
        backgroundColor: background,
        color: color,
      },
    };
  };

  const onSelectEventHandler = (date: any) => {
    // console.log(date);
  };

  const handleCalendarDate = (date: string) => {
    let dates = new Date(date);
    var first = new Date(dates.getFullYear(), dates.getMonth(), 1);
    var last = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let payload: any = {
      ...params,
      owner_due_date_from: moment(first).format("YYYY-MM-DD"),
      owner_due_date_to: moment(last).format("YYYY-MM-DD"),
    };
    if (payload.owner_due_date_from && payload.owner_due_date_to) {
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Start Date and End Date Required");
    }
  };

  const handleGetSpecificTaskInformation = async (id: string) => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = params.date ? new Date(params.date) : new Date();
      var owner_due_date_from = params.owner_due_date_from
        ? params.owner_due_date_from
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var owner_due_date_to = params.owner_due_date_to
        ? params.owner_due_date_to
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let resp = await GetSpecificCheckpointPEComplianceTask(id);
      if (resp) {
        // window.open(
        // 	`${window.location.origin}/activities/task/compliance/list/detail/${getValue(
        // 		mainParams,
        // 		`id`,
        // 		""
        // 	)}/${getValue(resp, `data.id`, "")}/${getValue(
        // 		resp,
        // 		`data.pe_compliance.checkpoint.id`,
        // 		""
        // 	)}/${moment(owner_due_date_from).format("YYYY-MM-DD")}/${moment(owner_due_date_to).format(
        // 		"YYYY-MM-DD"
        // 	)}/${getValue(resp, `data.pe_compliance.location.id`, "")}/${getValue(
        // 		resp,
        // 		`data.pe_compliance.function.id`,
        // 		""
        // 	)}`
        // );
      }
    } catch (error) {}
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const views = ["month", "agenda"];
  const handleNavigateBack = () => {
    let payload: any = {
      ...params,
      owner_due_date_from: convertDate(owner_due_date_from),
      owner_due_date_to: convertDate(owner_due_date_to),
    };
    let queryRequest = QueryRequestHelper(payload);
    return queryRequest;
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "activities_internal_compliance_executor_task"
      ) ? (
        <NoAccessPage />
      ) : isLoading || !props.permissionAPITriggered ? (
        <Loader />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <NavLink
                  // to={`/activities/self-compliance/my-task?owner_due_date_from=${convertDate(
                  // 	owner_due_date_from
                  // )}&owner_due_date_to=${convertDate(owner_due_date_to)}`}
                  to={`/activities/internal-compliance/my-task?${handleNavigateBack()}`}
                >
                  <img
                    src="/images/back-link.svg"
                    className="img-fluid add-filter-wrapper__upload-image"
                  />
                </NavLink>
              </div>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <div className="mr-3">
                <h4 className="dashbaord-wrapper__header-title">
                  My Task Calendar
                </h4>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div>
                <p style={{ fontSize: "10px" }}>Onwer Due Date</p>
                <DatePicker
                  selectsRange={true}
                  startDate={owner_due_date_from}
                  endDate={owner_due_date_to}
                  // className="form-control  ht-80"
                  // minDate={owner_due_date_from}
                  // maxDate={owner_due_date_to}
                  onChange={(update: any) => {
                    handleDate(update);
                  }}
                  dateFormat="d MMM yyyy"
                  // isClearable={true}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="react-date-picker__inputGroup__input"
                />
              </div>
              <button
                className="dashboard-wrapper__apply-btn mt-2"
                onClick={handleSubmitDate}
              >
                Apply
              </button>
            </div>
          </div>
          <div className="m-4">
            <Calendar
              popup
              views={views}
              defaultView="month"
              localizer={localizer}
              startAccessor="start"
              endAccessor="end"
              style={{ height: 500 }}
              events={taskDates}
              eventPropGetter={eventStyleGetter}
              onSelectSlot={(slotInfo: any) => onSelectEventHandler(slotInfo)}
              onSelectEvent={(slotInfo: any) =>
                onSelectEventSlotHandler(slotInfo)
              }
              onNavigate={(date: any) => {
                handleCalendarDate(date);
              }}
              components={{
                toolbar: CustomToolbar,
              }}
              defaultDate={
                getValue(params, `owner_due_date_from`, "")
                  ? new Date(getValue(params, `owner_due_date_from`, ""))
                  : new Date()
              }
              showMultiDayTimes
            />
          </div>

          {isOpen && (
            <Modal isOpen={isOpen} toggle={handleModal}>
              <ModalBody>
                <h5>
                  {moment(new Date(getValue(taskInfo, `start`, ""))).format(
                    "DD MMM YYYY"
                  )}
                  {" - "}
                  {getValue(taskInfo, `title`, "")}
                </h5>
                <div className="mt-3">
                  <h5>Task List</h5>
                  {getValue(taskInfo, `taskList`, []).map(
                    (item: any, index: number) => {
                      return (
                        <div className="d-flex justify-content-between mt-3">
                          <div className="d-flex">
                            <p className="calender_text ">{index + 1}.</p>
                            &nbsp;&nbsp;&nbsp;
                            <p className="calender_text ">
                              {getValue(item, `task_id`, "")}
                            </p>
                          </div>
                          <a
                            style={{ color: "#1A73E8", cursor: "pointer" }}
                            target="_blank"
                            onClick={() =>
                              handleGetSpecificTaskInformation(
                                getValue(item, `id`, "")
                              )
                            }
                          >
                            Open
                          </a>
                        </div>
                      );
                    }
                  )}
                </div>
              </ModalBody>
            </Modal>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default ICActivitiesMyTaskCalenderView;

class CustomToolbar extends Toolbar {
  constructor(props: any) {
    super(props);
  }
  handleDayChange = (event: any, value: any) => {
    value(event.target.value);
  };
  handleNavigate = (detail: any, elem: any) => {
    detail.navigate(elem);
  };
  render() {
    return (
      <div className="">
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="ascent-button  ascent-button--header-buttons ascent-button--primary"
            onClick={() => this.handleNavigate(this, "PREV")}
            style={{width: "40px", padding: "0", minWidth: "40px"}}
          >
            {/* Previous Month */}
            <div style={{transform: "rotate(90deg)", height: "32px", width: "38px", alignItems: "center", justifyContent: "center", display:"flex"}}><SubmenuArrowDownSvgComponent size={32} /></div>
          </button>
          <button
            type="button"
            className="ascent-button  ascent-button--header-buttons ascent-button--primary"
            onClick={() => this.handleNavigate(this, "TODAY")}
          >
            Today
          </button>
          
          <button
            type="button"
            className="ascent-button  ascent-button--header-buttons ascent-button--primary"
            onClick={() => this.handleNavigate(this, "NEXT")}
            style={{width: "40px", padding: "0", minWidth: "40px"}}
          >
            {/* Next Month */}
            <div style={{transform: "rotate(270deg)", height: "32px", width: "40px", alignItems: "center", justifyContent: "center", display:"flex"}}><SubmenuArrowDownSvgComponent size={32} /></div>
          </button>
        </div>
        <p style={{ textAlign: "center", fontSize: "18px" }} className="mb-2">
          {getValue(this.props, `label`, "")}
        </p>
      </div>
    );
  }
}
